import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

interface FlatCategory {
  _id: string;
  name: string;
  bhk: 'One' | 'Two' | 'Three' | 'Four' | 'Studio';
  feature: string;
  createdAt: string; // ISO 8601 date string
  updatedAt: string; // ISO 8601 date string
  __v: number;
}
interface FlatState {
  flatCategory: FlatCategory[];
  loading: boolean;
  error: string | null;
}

const initialState: FlatState = {
  flatCategory: [],
  loading: false,
  error: null,
};

export const getFlatCategories = createAsyncThunk(
  "flat/getFlatCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/flat-types`);
      return response?.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch flat category"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
    }
  }
);

const flatSlice = createSlice({
  name: "flat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFlatCategories.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFlatCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.flatCategory = action.payload;
      })
      .addCase(getFlatCategories.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "An error occurred. Please try again.";
      });
  },
});

export default flatSlice.reducer;
